export default {
  apiKey: "AIzaSyD7q35Ws_JI_P_rvp8TkH3H224X5_1Atag",
  authDomain: "sole-strategies.firebaseapp.com",
  projectId: "sole-strategies",
  storageBucket: "sole-strategies.appspot.com",
  messagingSenderId: "778572453226",
  appId: "1:778572453226:web:0bf54d36a3440a7de20113",
  measurementId: "G-WEEJEBM5VN"
};